<template>
  <div class="ml-comparison-board__container ml-card--depth mb-4">
    <div class="ml-comparison-board__tabs">
      <div
        v-on:click="selectTab(index)"
        :key="`${category.title}#${index}`"
        v-for="(category, index) in categories"
        :id="`comparison-board-tab-${category.title.toLowerCase().replace(' ', '-')}`"
        :class="{'ml-comparison-board__tab': true, 'ml-comparison-board__tab--active': (index === selectedTab)}">

        <div class="ml-comparison-board__category-title">
          {{ category.title }}
        </div>

        <div class="ml-comparison-board__category-total">
          {{ category.total }} {{ category.unit }}
        </div>

        <div
          v-bind:class="{
            'ml-comparison-board__category-performance': true,
            'ml-comparison-board__category-performance--max': !category.invert ? (category.performance > 0) : (category.performance < 0),
            'ml-comparison-board__category-performance--min': !category.invert ? (category.performance < 0) : (category.performance > 0)}">
          <i class="material-icons" v-show="category.performance < 0">arrow_downward</i>
          <i class="material-icons" v-show="category.performance > 0">arrow_upward</i>
          {{ category.performance }}%
        </div>

        <div class="ml-comparison-board__category-prompt">
          vs {{ category.data[1].name }}
        </div>
      </div>
    </div>

    <div class="ml-comparison-board__chart-container" v-if="!hide">
      <chart v-show="selectedCategory" :data="selectedCategory.data" height="200px"></chart>
    </div>

    <div class="ml-comparison-board__filter-container row no-gutters">
      <div class="align-items-center col-4 d-flex justify-content-start">
        <b-datepicker 
          class="mx-1" 
          icon="calendar-today" 
          :readonly="true" 
          placeholder="Date from"
          v-model="range.from" :max-date="range.to" @input="rebuildChart"></b-datepicker>
        <span class="mx-3">to</span>
        <b-datepicker 
          class="px-1" 
          icon="calendar-today" 
          :readonly="true" 
          placeholder="Date to"
          v-model="range.to" :min-date="range.from" @input="rebuildChart"></b-datepicker>
      </div>
    </div>
  </div>
</template>

<script>
import Chart from '@/components/Chart'

export default {
  name: 'ComparisonBoard',

  data () {
    return {
      hide: false,
      range: {
        from: (new Date((Math.round((new Date()).getTime() / 1000) - (7 * 24 * 60 * 60)) * 1000)),
        to: (new Date((Math.round((new Date()).getTime() / 1000)) * 1000))
      },
      selectedTab: 0,
      selectedCategory: false,
      prompts: {
        'week': 'vs last 7 Days',
        '2week': 'vs last 2 Weeks',
        'month': 'vs last Month'
      }
    }
  },

  computed: {
    categories () {
      return this.data.data
    }
  },

  components: {
    Chart
  },

  methods: {
    rebuildChart () {
      // Set the time range
      this.$emit('filter-chart', {
        from: (this.range.from.getTime() / 1000),
        to: (this.range.to.getTime() / 1000) + ((24 * 60 * 60) - 1)
      })
    },
    selectTab (index) {
      this.selectedTab = index
      // Allocate the selected category
      this.selectedCategory = this.categories[index]
    }
  },
  mounted () {
    this.rebuildChart()
  },

  props: {
    data: {
      required: true
    }
  },
  watch: {
    data () {
      this.selectedCategory = this.categories[this.selectedTab]
    }
  }
}
</script>

<style lang="scss">
  @import "../styles/theme";

  .ml-comparison-board__container {
    position: relative;
  }

  .ml-comparison-board__container-tooltip {
    position: absolute;
    bottom: -22px;
    right: 46.5%;

    margin: 0 auto;
    padding: .075rem .5rem .125rem;

    background-color: $background-white;
    border-radius: 5px;
    box-shadow: 0 7px 14px 0 rgba(50,50,93,.1), 0 3px 6px 0 rgba(0,0,0,.07);
    cursor: pointer;
    pointer-events: all;
  }

  .ml-comparison-board__tabs {
    align-items: flex-start;
    display: flex;
    justify-content: space-between;
  }

  .ml-comparison-board__category-title,
  .ml-comparison-board__category-total,
  .ml-comparison-board__category-performance,
  .ml-comparison-board__category-prompt {
    padding: 1px 0;
    text-align: center;
  }

  .ml-comparison-board__category-prompt {
    display: none;
    color: $tingg-grey;
    padding: 5px 0;
  }

  .ml-comparison-board__tab {
    cursor: pointer;
    padding: 10px 35px;
  }

  .ml-comparison-board__tab.ml-comparison-board__tab--active {
    border-top: 3px solid $tingg-purple;
  }

  .ml-comparison-board__tab.ml-comparison-board__tab--active .ml-comparison-board__category-prompt {
    display: block;
  }

  .ml-comparison-board__category-title {
    font-size: 14px;
    font-weight: 600;
  }

  .ml-comparison-board__category-total {
    font-size: 16px;
  }

  .ml-comparison-board__category-performance {
    color: $tingg-purple;
    font-size: 12px;
  }

  .ml-comparison-board__category-performance--min {
    color: $tingg-primary-red !important;
  }

  .ml-comparison-board__category-performance--max {
    color: $tingg-green !important;
  }

  .ml-comparison-board__category-prompt {
    font-size: 10px;
  }

  .ml-comparison-board__filter-container {
    border-top: 1px solid $tingg-white;
    padding: 15px 10px;
  }

  .ml-comparison-board__chart-container {
    padding: 15px 20px 15px 5px;
  }
</style>



// WEBPACK FOOTER //
// src/components/ComparisonBoard.vue